import { subGroup, route, meta } from '@/helpers/routes'
import Index from './index/notifications'

const routes = [
  route('index', '/index', Index, meta('Minhas Notificações', true, 'guest'))
]

export default subGroup('/patient/notifications', routes)



// WEBPACK FOOTER //
// ./src/app/patient/notifications/routes.js